// src/pages/Budget/format.js
// Форматирование и разбор чисел АРМ «Доходы и расходы». Это ОТОБРАЖЕНИЕ, а не
// «вычисление содержания»: значения приходят готовыми с сервера, здесь лишь
// приводятся к виду отчёта.
//   разделитель групп — узкий неразрывный пробел (U+202F)
//   десятичный — запятая, минус — «−» (U+2212), выравнивание задаётся CSS (tabular-nums)

const NBSP = '\u202F';
const MINUS = '\u2212';
const DASH = '—';

const isNum = (v) => v !== null && v !== undefined && v !== '' && !Number.isNaN(Number(v));

// Число с фиксированной точностью. null/пусто → «—», 0 → «0,0» (при digits=1).
export function fmtNum(v, digits = 1) {
  if (!isNum(v)) return DASH;
  const n = Number(v);
  const s = Math.abs(n).toFixed(digits);
  const [int, frac] = s.split('.');
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, NBSP);
  const body = frac != null ? `${grouped},${frac}` : grouped;
  return (n < 0 ? MINUS : '') + body;
}

// Суммы перечня/формы: тыс. ₸, 1 знак.
export const fmtSum = (v) => fmtNum(v, 1);

// Невязка тождества: 3 знака.
export const fmtResid = (v) => fmtNum(v, 3);

// Процент: 2 знака + « %». null → «—». Сверху не ограничивается.
export function fmtPct(v) {
  if (!isNum(v)) return DASH;
  return `${fmtNum(v, 2)} %`;
}

// Разбор ввода суммы: точка и запятая как десятичный разделитель, пробелы — группы.
// Пусто → null (нет данных, не ноль). Некорректно → NaN.
export function parseAmount(raw) {
  if (raw === null || raw === undefined || String(raw).trim() === '') return null;
  const x = String(raw).replace(/\s/g, '').replace(',', '.');
  if (!/^-?\d+(\.\d{1,5})?$/.test(x)) return NaN;
  return Number(x);
}

// Для повторного показа сохранённого числа в поле ввода (точка → запятая).
export function toInput(v) {
  if (v === null || v === undefined) return '';
  return String(v).replace('.', ',');
}
